import React from "react";
import { Link } from "react-router-dom";
import { CaretDown } from "@phosphor-icons/react";

export const navGroups = [
  { label: "Couch", links: [
    { to: "/therapists", label: "Find a Therapist" },
    { to: "/couch/how-it-works", label: "How It Works" },
    { to: "/couch/mental-wellbeing", label: "Mental Wellbeing" },
    { to: "/couch/cognitive-support", label: "Cognitive & Neuropsych Support" },
    { to: "/couch/pricing", label: "Sessions & Pricing" },
  ]},
  { label: "Forward", links: [
    { to: "/find-a-mentor", label: "Find a Mentor" },
    { to: "/forward/packages", label: "Packages" },
    { to: "/forward/how-it-works", label: "How It Works" },
  ]},
  { label: "For Organisations", links: [
    { to: "/organisations/corporate", label: "Corporate Wellness" },
    { to: "/organisations/schools", label: "School Workshops" },
    { to: "/organisations/career-workshops", label: "Psychology Career Workshops" },
  ]},
];

/** Desktop nav rendered inside the header. Receives the currently-open dropdown
 * label + setter from the parent so dropdowns stay coordinated with profile/cart. */
export default function HeaderNav({ openDrop, setOpenDrop }) {
  return (
    <nav className="hidden lg:flex items-center gap-6" data-testid="site-nav">
      <Link to="/about" className="md-nav-link" data-testid="nav-about">About Us</Link>
      {navGroups.map((g) => (
        <div key={g.label} className="md-nav-drop-wrap" onMouseEnter={() => setOpenDrop(g.label)} onMouseLeave={() => setOpenDrop(null)}>
          <button className="md-nav-link flex items-center gap-1" data-testid={`nav-${g.label.toLowerCase().replace(/\s+/g, "-")}`}>
            {g.label} <CaretDown size={11} weight="bold" />
          </button>
          {openDrop === g.label && (
            <div className="absolute left-0 top-full pt-3">
              <div className="bg-white rounded-lg shadow-xl border min-w-[260px] overflow-hidden" style={{ borderColor: "var(--md-border)" }}>
                {g.links.map((l) => (
                  <Link key={l.to} to={l.to} className="block px-5 py-3 text-sm hover:bg-[#EEF4E8]" data-testid={`nav-link-${l.to.replace(/\//g, "-")}`}>
                    {l.label}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
      <Link to="/events" className="md-nav-link" data-testid="nav-events">Events</Link>
      <Link to="/shop" className="md-nav-link" data-testid="nav-shop">Shop</Link>
      <Link to="/career" className="md-nav-link" data-testid="nav-career">Career</Link>
      <Link to="/faqs" className="md-nav-link" data-testid="nav-faqs">FAQ</Link>
    </nav>
  );
}
